<template>
    <client-page>
        <sub-visual sh="About IST" tabActive="Company History" bg="/images/sub/visual/sv1.png"> </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit">Company History</h2>
            </v-container>
            <top-image src="/images/sub/about/history/his-img1.png"> </top-image>
            <v-container>
                <v-row>
                    <v-col cols="12" md="4" lg="5">
                        <div class="his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0">
                            <p class="page-text-lg mb-8 mb-lg-20">History of the IST</p>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block">2022<span class="d-inline-block d-md-none mx-6">~</span></h2>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4">2012 <span class="d-none d-md-inline-block">~</span></h2>
                        </div>
                    </v-col>
                    <v-col cols="12" md="8" lg="7">
                        <div class="pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden">
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 45001 : 2018 Certificate of Registration <br class="d-none d-md-block" />Health Safety Management System</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">3rd Stage of Smart Factory Development <br class="d-none d-md-block" />(Since 2019)</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 27001 : 2013 Certificate of Registration <br class="d-none d-md-block" />Information Security Management System</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2014</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">Change of Company Name <br class="d-none d-md-block" />(IS Techno Co. Ltd. to IST Co., Ltd.)</p>
                            </div>
                            <div class="d-flex align-center">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2012</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 14001 : 2015 Certificate of Registration <br class="d-none d-md-block" />Environmental Management System</p>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section">
            <top-image src="/images/sub/about/history/his-img2.png"> </top-image>
            <v-container>
                <v-row class="flex-column-reverse flex-md-row justify-start">
                    <v-col cols="12" md="8" lg="7">
                        <div class="pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden">
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2008</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">R&D Established (No. 2008110774)</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2007</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 9001 : 2015 Certificate of Registration <br class="d-none d-md-block" />Quality Management System</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2003</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">IST USA Inc. U.S Office Established</p>
                            </div>
                            <div class="d-flex align-center">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">1996</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">IS Techno Ltd. Established</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4" lg="5" class="d-flex justify-md-end">
                        <div class="his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0">
                            <p class="page-text-lg mb-8 mb-lg-20">History of the IST</p>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block">2008<span class="d-inline-block d-md-none mx-6">~</span></h2>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4">1996 <span class="d-none d-md-inline-block">~</span></h2>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <div class="history-text">
                    <p class="tit font-weight-bold text-center">
                        Highest quality CMP Retainer Ring processing and <br class="d-none d-lg-block" />
                        Semiconductor equipment consumables & equipment <br class="d-none d-lg-block" />
                        distribution company
                    </p>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import TopImage from "@/components/client/en/sub/sub-top-image.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
    },
};
</script>

<style lang="scss" scoped>
.his-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    background-color: #fff;
    position: relative;
}
.his-point::after {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.his-year {
    position: relative;
    z-index: 1;
    width: 100%;
    background-color: var(--v-primary-base);
    height: fit-content;
}

.his-detail h3 {
    min-width: 49px;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .his-year {
        width: 410px;
        max-width: 100%;
        top: -100px;
    }
    .his-detail {
        position: relative;
    }
    .his-detail::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 0;
        width: 1px;
        height: 100%;
        background-color: var(--border-color);
        bottom: 16px;
        left: 122px;
    }
    .his-detail h3 {
        min-width: 74px;
    }
}
@media (min-width: 1024px) {
    .his-year {
        top: -150px;
    }
    .his-point {
        width: 16px;
        height: 16px;
    }
    .his-point::after {
        width: 8px;
        height: 8px;
    }
    .his-detail::before {
        bottom: 20px;
        left: 182px;
    }
    .his-detail h3 {
        min-width: 84px;
    }
}
@media (min-width: 1200px) {
}
</style>